
$(document).ready(function() {

	// swedish translation for datepicker
	$.fn.datepicker.dates['sv'] = {
	  days: ["Söndag", "Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag", "Söndag"],
	  daysShort: ["Sön", "Mån", "Tis", "Ons", "Tor", "Fre", "Lör", "Sön"],
	  daysMin: ["Sö", "Må", "Ti", "On", "To", "Fr", "Lö", "Sö"],
	  months: ["Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December"],
	  monthsShort: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
	  today: "I Dag",
	  format: "yyyy-mm-dd",
	  weekStart: 1
	};

});
